import { buttonVariants } from '@/app/common/components/Button'
import { Card, CardContent } from '@/app/common/components/Card'
import { InfoCircleIcon } from '@/app/common/icons/general'
import { AppRoutePaths } from '@/routing/route_paths'
import { PaymentDetail } from '@/schemas/payments.schema'
import { Link } from 'react-router-dom'

type Props = {
  payment: PaymentDetail
}

export function AppealPayProviderAndReimbursement(props: Props) {
  const { payment } = props

  const isPayProvider = payment.type === 'Pay Provider'

  const appealName = isPayProvider ? 'Pay Provider' : 'Reimbursement'
  return (
    <Card className="mb-4">
      <CardContent className="flex items-center justify-between">
        <div className="flex gap-2 items-center">
          <InfoCircleIcon className="text-blue-500 text-2xl" />
          <div>
            <h2 className="font-medium">Appeal {appealName}</h2>
            <p className="text-gray-600 text-sm">
              If you believe that this decision was made in error, you can
              appeal the decision.
            </p>
          </div>
        </div>
        <Link
          className={buttonVariants({
            variant: 'primary',
          })}
          to={AppRoutePaths.payments_appeals.id.replace(
            ':id',
            payment.payment_id.toString()
          )}
        >
          Appeal Decision
        </Link>
      </CardContent>
    </Card>
  )
}
